export class TipoVia {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public nombre: string | undefined;
}